<template>
  <!-- 最新动态 -->
  <div class="recent_news">
    <div class="zong">
      <div class="news_left">
        <!-- 标题 -->
        <div class="title">
        <h1 :class="{'animate__animated': isVisible, 'animate__bounceInLeft': isVisible, 'fixed-text': isFixed}" 
            style="color:#76BD25;" 
            v-show="isVisible"
            @animationend="handleAnimationEnd">
          RECENT <br>NEWS
        </h1>
        <h1 style="color:#76BD25;" :class="{ 'animate__animated': isVisible, 'animate__fadeIn': isVisible }"
        v-show="isVisible"
            @animationend="handleAnimationEnd">———</h1>
        <h1
          :class="{'animate__animated': isVisible, 'animate__bounceInLeft': isVisible, 'fixed-text': isFixed}" 
          v-show="isVisible"
            @animationend="handleAnimationEnd">
          最新动态
        </h1>
      </div>
      <!-- 小目录 -->
        <div class="viewbig">
          <div class="view">
            <ul>
              <li
                :class="{'active': isxian === 'xwzx'}"
                @click="recentClick('xwzx')"
              >
                <a>新闻中心</a>
              </li>
              <li
                :class="{'active': isxian === 'tzgg'}"
                @click="recentClick('tzgg')"
              >
                <a>通知公告</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="news_right">
        <div
          class="xwzx clearfix fl"
          v-if="isxian==='xwzx'"
        >
          <div class="right">
            <div class="nav clearfix">
              <el-menu
                :default-active="activeIndex"
                class="el-menu-demo fl"
                mode="horizontal"
                @select="handleSelect2"
              >
                <el-menu-item index="1">
                  企业新闻
                </el-menu-item>
                <el-menu-item index="2">
                  行业新闻
                </el-menu-item>
                <el-menu-item index="3">
                  法律法规
                </el-menu-item>
              </el-menu>
              <div
                class="fr more"
                @click="more()"
              >
                更多...
              </div>
            </div>
            
            <ul
              class="content content1"
              v-if="isShow == 'content1' ? true : false"
            >
              <li
                v-for="(item) in newsList"
                :key="item.id"
                class="pr"
              >
                <router-link :to="'/news/qyxw/qyxwxq' +'?id='+ item.id">
                  <span class="text">{{ item.text }}</span><span class="date">{{ item.date }}</span>
                </router-link>
              </li>
            </ul>
            <ul
              class="content content2"
              v-if="isShow == 'content2' ? true : false"
            >
              <li
                v-for="(item) in newsList"
                :key="item.id"
                class="pr"
              >
                <router-link :to="item.route">
                  <span class="text">{{ item.text }}</span><span class="date">{{ item.data }}</span>2
                </router-link>
              </li>
            </ul>
            <ul
              class="content content3"
              v-if="isShow == 'content3' ? true : false"
            >
              <li
                v-for="(item) in flfg"
                :key="item.id"
                class="pr"
              >
                <router-link :to="{name:'flfgxq',query:{id:item.id}}">
                  <span class="text">{{ item.title }}</span><span class="date">{{ item.date }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="zxgg clearfix fl"
          v-else
        >
          <ul class="content">
            <li
              v-for="(item) in news"
              :key="item.id"
              class="pr"
            >
              <router-link :to="{name:'gsggxq',query:{id:item.id}}">
                <span>{{ item.title }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { request } from '../../assets/utils/request'
export default {
  data() {
    return {
      isShow: 'content3',
      activeIndex: '3',
      news: [],
      newsList: [],
      flfg:[],
      isxian: 'xwzx',
      decoration: '',
      isVisible: false,
      scrollY: 0,
      isFixed: false,
    }
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (this.scrollY >= 200) {
        this.isVisible = true;
      }
    },
    handleAnimationEnd() {
      this.isFixed = true;
    },
    recentClick(type) {
      this.isxian = type
    },
        handleSelect(key) {
          if(key == 1){
            this.$data.activeIndex = "1"
          }else if(key ==2){
            this.$data.activeIndex = "2"
          }
        },
        handleSelect2(key){
          this.$data.isShow = "content" + key
        },
        getNews: function() {
            var that = this;
            request('/mocks/news/gsggxq.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.news = data
                    } catch (e) {
                        that.news = [];
                    }
                }
            })
        },
        getNewList() {
          var that = this;
            request('/mocks/news/qyxw.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        let mdata = data.filter(item => {return item.id <= 5})
                        that.newsList = mdata
                    } catch (e) {
                        that.newsList = [];
                    }
                }
            })
        },
        getflfg() {
          var that = this;
            request('/mocks/news/flfgxq.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        let mdata = data.filter(item => {return item.id <= 5})
                        that.flfg = mdata
                    } catch (e) {
                        that.flfg = [];
                    }
                }
            })
        },
        more() {
          if(this.isShow == "content1") {
            this.$router.push('/news/qyxw')
          }else if(this.isShow == "content2") {
            this.$router.push('/news/hyxw')
          }else{
            this.$router.push('/news/flfg')
          }
        }
    },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
      this.getNews();
      this.getNewList();
      this.getflfg()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
    /* 最新修改 */
    .recent_news{
      align-items: center;
      justify-content: center;
      max-width: 100vw;
      width: 100%;
      height: 880px;
      position: relative;
    }
    .recent_news::after{
      z-index: -100;
      position: absolute;
      background-image: url("../../assets/images/new/gude.jpg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      top: 0;
      content: '';
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0.05;
    }
    .zong{
      margin: 0 auto;
      max-width: 1200px;
      display:flex;
      height: 820px;
      align-items: center;
      justify-content: space-around;
      flex-direction: row;
    }
    .news_left{
      width: 400px;
      display: flex;
      flex-direction: column;
    }
    .title{
      max-width: 400px;
      flex-direction: column;
    }
    .title h1{
      font-size: 2.5rem;
      font-weight: bolder;
    }
    .viewbig{
      max-width: 400px;
      margin-top: 136px;
      height: 300px;
      font-size: 1.5rem;
      font-weight:500;
      line-height: 76px;
    }
    .view ul {
      cursor: pointer;
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    .view ul li a {
      text-decoration: none;
      padding-bottom: 5px;
      position: relative;
    }
    .active a::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 5px;
      background-color: #5bb62d;
      transition: left 0.3s;
      border-radius:25px;
    }
    .news_right{
      max-width: 800px;
      height: 500px;
    }
    /* 新闻中心 */

    .el-menu--horizontal>.el-menu-item.is-active{
      border-bottom: 0;
    }
    .el-menu--horizontal>.el-menu-item.is-active::after{
      position: absolute;
      content: "";
      width: 40px;
      height: 4px;
      background: #5bb62d;
      bottom: 0;
      left: 50%;
      margin-left: -20px;
      display: block;
      border-radius: 5px;
    }
    .el-menu--horizontal>.el-menu-item{
      border: 0;
      font-size: 30px;
    }
    .fl{
      background-color:transparent;
    }
    .nav .more{
      line-height: 45px;
      margin-right: 45px;
      color: #76bd25;
      cursor: pointer;
    }
    a{
      color: #333;
      text-decoration: none;
    }
    a:visited,a:hover{
      color: #333;
    }
    .xwzx{
      display: flex;
      width: 400px;
      background-size: 350px;
    }
    .xwzx .right{
      padding:86px 0 0 0;
    }
    .xwzx .el-menu--horizontal>.el-menu-item{
      width: 90px;
    }
    .xwzx .el-menu--horizontal>.el-menu-item.is-active{
      color: #5bb62d!important;
    }
    .xwzx .el-menu--horizontal>.el-menu-item.is-active[data-v-fae5bece]::after{
      background: #5bb62d;
    }
    .xwzx .el-menu.el-menu--horizontal{
      border-bottom: none;
    }
    .xwzx .el-menu--horizontal>.el-menu-item.is-active,.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,.el-submenu__title:hover{
      color:#5bb62d!important;
    }
    .xwzx .el-menu-demo{
      max-width: 300px;
      margin: 0 auto;
    }
    .xwzx .content{
      margin-top: 30px;
    }
    .xwzx .content li{
      padding-left: 15px;
      height: 40px;
      line-height: 40px;
    }
    .xwzx .content li::before{
      content: "";
      width: 7px;
      height: 7px;
      border-radius: 7px;
      background: #5bb62d;
      position: absolute;
      left:-3px;
      top: 50%;
      margin-top: -3px;
    }
    .xwzx .content li .text{
      display: inline-block;
      max-width: 280px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: text-bottom;
    }
    .xwzx .content li .date{
      color: #d7d5d5;
      float: right;
      padding-right: 50px;
    }
    .zxgg{
      display: flex;
      width: 400px;
    }
    .zxgg .content{
      margin-top: 200px;
      margin-right: 30px;
    }
    .zxgg .content li{
      height: 40px;
      line-height: 40px;
      padding-left: 15px;
    }
    .zxgg .content li span{
      max-width: 350px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
    }
    .zxgg .content li::before{
      content: "";
      width: 7px;
      height: 7px;
      border-radius: 7px;
      background: #5bb62d;
      position: absolute;
      left:-3px;
      top: 50%;
      margin-top: -3px;
    }
    .content a,.content span{
      color: #909090;
    }
    @media (max-width: 1200px){
      .news_left{
        flex-direction: row;
      }
      .news_left .title{
        padding-top: 100px;
      }
      .news_left .viewbig{
        padding-left: 100px;
      }
      .zong{
        flex-direction: column;
      }
      .xwzx .right{
        padding:0 0 0 0;
        margin-bottom: 30px;
    }
    .zxgg .content{
      margin-top: -40px;
      padding-left: 80px;
    }
    .title h1{
      font-size: 2.0rem;
    }
    .news_right{
      font-size: 0.8rem;
    }
    .xwzx .content li{
      padding-left: 30px;

    }
    .xwzx .content li::before{
      left:9px;
    }
  }
    @media (max-width: 500px){
      .news_left .title{
        padding-top: 140px;
        padding-left: 80px;
      }
    .title h1{
      font-size: 1.5rem;
    }
    .viewbig{
      font-size: 1.0rem;
    }
    .news_right{
      font-size: 0.6rem;
    }
    .news_right{
      padding-left: 80px;
    }
    }
</style>